import { Injectable } from '@angular/core';
import { Util } from '@phdsoft/common';
import { DocumentPropertiesMapper } from './models/document-properties.model';
import { ElementPropertiesMapper } from './mappers/element-properties-mapper';
import { DTSelectionService } from 'src/app/digital-twin/selection/selection.service';
import { Modes } from 'src/app/platform/busines-data/Framework/mode';
import { SensorPropertiesMapper } from './mappers/sensor-properties-mapper';
import { AssetManager } from '@app/asset-manager/asset-manager';

enum SelectedObjectType {
  StructuralElement,
  Document,
  Sensor,
  CriticalArea
}

@Injectable({
  providedIn: 'root'
})
export class PropertiesWindowService {

  constructor(
    private dTSelectionService: DTSelectionService,
    private assetManager: AssetManager,
  ) { }

  public getMappedObject(data: any, isDegradationModeOpen?: boolean): any {
    if (Util.isNullOrUndefined(data)) {
      return null;
    }
    const mode = data.mode;
    let type: SelectedObjectType = this.getSelectedObjectType(data, mode);
    return this.MapObjectAccordingToType(type, data, isDegradationModeOpen);
  }

  private getSelectedObjectType(data: any, mode: Modes): SelectedObjectType {
    if ('sensorProperties' in data) {
      return SelectedObjectType.Sensor;
    }
    if ('DocumentType' in data) {
      return SelectedObjectType.Document;
    }
    if(data.CriticalAreaProperties) {
      return SelectedObjectType.CriticalArea;
    }
    if (!Util.isNullOrUndefined(data) && (mode === "SECTIONS" || (this.assetManager.asset.mode === 'REGIONS' &&
      this.assetManager.functionalityMode === 'INSPECTIONINSERTION'))) {
      return SelectedObjectType.StructuralElement;
    }
  }

  regionsList: string = null

  private MapObjectAccordingToType(type: SelectedObjectType, selectedObject: any, isDegradationModeOpen?: boolean): any {
    switch (type) {
      case SelectedObjectType.StructuralElement:
        if (selectedObject?.properties?.RegionIds) {
          this.regionsList = selectedObject?.properties?.RegionIds?.map((regionId: string) => {
            return this.dTSelectionService.getRegionProperties(regionId);
            }).filter(region => region !== undefined);
          } else {
            this.regionsList = selectedObject?.regionIds?.map((regionId: string) => {
            return this.dTSelectionService.getRegionProperties(regionId);
            }).filter(region => region !== undefined);
          }

        let section = this.dTSelectionService.getSectionProperties(selectedObject?.properties?.SectionId);

        if (!Util.isNullOrUndefined(selectedObject.properties?.Computed?.AverageThickness)) {
          selectedObject.properties.Computed.AverageThickness = selectedObject.meanThicknessValue ?? 0;
        }
        if (selectedObject.properties?.TypeName === "Stiffener" || selectedObject.properties?.TypeName === "Bracket") {
          if (selectedObject.properties?.Geometry?.WebThickness != 0) {
            selectedObject.properties.Computed.AverageWebThickness = selectedObject.getMeanThicknessByScope('ONLY WEB') ?? 0;
          } else if (selectedObject.properties?.Geometry?.FlangeThickness != 0) {
            selectedObject.properties.Computed.AverageFlangeThickness = selectedObject.getMeanThicknessByScope('ONLY FLANGE') ?? 0;
          }
        }
        return ElementPropertiesMapper.MapToVisualizationMode(selectedObject, this.regionsList, section, isDegradationModeOpen, this.assetManager.showComputeDimensions);
      case SelectedObjectType.Document:
        return DocumentPropertiesMapper.MapToVisualizationMode(selectedObject)
      case SelectedObjectType.Sensor:
        return SensorPropertiesMapper.MapToVisualizationMode(selectedObject.sensorProperties);
      case SelectedObjectType.CriticalArea:
        return null;
      default:
        return selectedObject;
    }
  }
}
